import React from 'react';

import { Box } from '@mui/material';

import { Formik } from 'formik';

import Button from '../../../../components/Button/Button';
import { FormValue, StepOneFormValue, StepTwoFormValue, stepTwoSchema } from '../schema';
import { Form2 } from './Forms/Form2';
import './style.css';

type Props = {
  data: StepTwoFormValue & StepOneFormValue;
  handleNext: (values: StepTwoFormValue & StepOneFormValue) => void;
  handlePersistFormDataStep?: (values: Partial<FormValue>) => void;
};

export const Step2: React.FC<Props> = ({ data, handleNext, handlePersistFormDataStep }) => {
  return (
    <Formik
      enableReinitialize
      initialValues={data}
      validationSchema={stepTwoSchema}
      onSubmit={(values) => {
        handleNext(values);
      }}
    >
      {({ values, handleSubmit }) => {
        return (
          <Box component={'form'} onSubmit={handleSubmit}>
            <Form2 values={values} handlePersistFormDataStep={handlePersistFormDataStep} />
            <Box mt={6}>
              <Button fullWidth variant='contained' type='submit' sx={{ px: '5rem', py: '1rem' }}>
                Next
              </Button>
            </Box>
          </Box>
        );
      }}
    </Formik>
  );
};
